import _ from "underscore";
export class MillenniumWeekday {
    static SUNDAY = new MillenniumWeekday(0, "sun");
    static MONDAY = new MillenniumWeekday(1, "mon");
    static TUESDAY = new MillenniumWeekday(2, "tue");
    static WEDNESDAY = new MillenniumWeekday(3, "wed");
    static THURSDAY = new MillenniumWeekday(4, "thu");
    static FRIDAY = new MillenniumWeekday(5, "fri");
    static SATURDAY = new MillenniumWeekday(6, "sat");
    static WEEKDAYS = [
        MillenniumWeekday.SUNDAY,
        MillenniumWeekday.MONDAY,
        MillenniumWeekday.TUESDAY,
        MillenniumWeekday.WEDNESDAY,
        MillenniumWeekday.THURSDAY,
        MillenniumWeekday.FRIDAY,
        MillenniumWeekday.SATURDAY,
    ];
    absoluteWeekdayNumber;
    representation;
    constructor(absoluteWeekdayNumber, representation) {
        this.absoluteWeekdayNumber = absoluteWeekdayNumber;
        this.representation = representation;
    }
    getRepresentation() {
        return this.representation;
    }
    getAbsoluteWeekdayNumber() {
        return this.absoluteWeekdayNumber;
    }
    getDay() {
        return this.absoluteWeekdayNumber;
    }
    // Only counts forward, i.e. Saturday is 5 days from Monday
    daysFromWeekday(weekday) {
        if (!(weekday instanceof MillenniumWeekday)) {
            throw new Error("daysFromWeekday must be invoked with a MillenniumWeekday");
        }
        const thisDay = this.getAbsoluteWeekdayNumber();
        const otherDay = weekday.getAbsoluteWeekdayNumber();
        if (otherDay > thisDay) {
            return 6 - thisDay;
        }
        return thisDay - otherDay;
    }
    daysFromMonday() {
        return this.daysFromWeekday(MillenniumWeekday.MONDAY);
    }
    equals(obj) {
        if (this === obj) {
            return true;
        }
        if (obj === null || obj === undefined) {
            return false;
        }
        if (!(obj instanceof MillenniumWeekday)) {
            return false;
        }
        return this.getAbsoluteWeekdayNumber() === obj.getAbsoluteWeekdayNumber();
    }
    // @returns The weekdays starting with the firstDayOfWeek
    // Currently only supports Sunday and Monday, Sunday being the default
    /* Better!
            const firstDayOfWeek = Language.firstDayOfWeek.absoluteWeekdayNumber;
            return _.range(0, 7).map(index => {
                return MillenniumWeekday.WEEKDAYS[(index + firstDayOfWeek) % 7];
            }, this);
    */
    static getLocalizedWeekdayList(firstDayOfWeek) {
        const values = _.clone(MillenniumWeekday.WEEKDAYS);
        if (firstDayOfWeek === MillenniumWeekday.MONDAY) {
            const sunday = values.shift();
            values.push(sunday);
        }
        return values;
    }
    static getByRepresentation(representation) {
        let property;
        for (property in MillenniumWeekday) {
            if (MillenniumWeekday.hasOwnProperty(property)) {
                if (MillenniumWeekday[property] instanceof MillenniumWeekday) {
                    if (MillenniumWeekday[property].getRepresentation() === representation) {
                        return MillenniumWeekday[property];
                    }
                }
            }
        }
        throw new Error(`No weekday \"${representation}\".`);
    }
    static getByWeekdayNumber(weekdayNumber) {
        let property;
        for (property in MillenniumWeekday) {
            if (MillenniumWeekday.hasOwnProperty(property)) {
                if (MillenniumWeekday[property] instanceof MillenniumWeekday) {
                    if (MillenniumWeekday[property].getAbsoluteWeekdayNumber() === weekdayNumber) {
                        return MillenniumWeekday[property];
                    }
                }
            }
        }
        throw new Error(`No weekday \"${weekdayNumber}\".`);
    }
}
